<div class="wrap">
    <div class="spin">
      <kendo-loader
        [type]="loader.type"
        [themeColor]="loader.themeColor"
        [size]="loader.size"
      >
      </kendo-loader>
    </div>
  </div>
  